const Config = {
    graphql_host: 'https://api.placenevolani.cz/graphql',
    websocket_host: 'wss://api.placenevolani.cz/subscriptions',
//    websocket_host: 'ws://wsapi.placenevolani.cz/subscriptions',
//    graphql_host: 'http://dev.placenevolani.cz:3000/graphql',
//    websocket_host: 'ws://dev.placenevolani.cz:3001/subscriptions',


    basename: '',
    sentry_dsn: 'https://79fd9c1aa9794037863eecfc4d5df1d5@sentry.id-sign.com/11',
    help_number: '+420 739 660 888'
};

export {Config};



// WEBPACK FOOTER //
// ./src/app.config.js